import {
  EComparisonOperators,
  EComparisonOperatorsDisplayText,
} from '../interfaces/operator.interface';

export function getDisplayTextForComparisonOperator(
  operator :EComparisonOperators,
) :string {
  switch (operator) {
    case EComparisonOperators.GREATER_THAN:
      return EComparisonOperatorsDisplayText.GREATER_THAN;
    case EComparisonOperators.LESSER_THAN:
      return EComparisonOperatorsDisplayText.LESSER_THAN;
    case EComparisonOperators.GREATER_THAN_OR_EQUAL:
      return EComparisonOperatorsDisplayText.GREATER_THAN_OR_EQUAL_TO;
    case EComparisonOperators.LESSER_THAN_OR_EQUAL:
      return EComparisonOperatorsDisplayText.LESSER_THAN_OR_EQUAL_TO;
    case EComparisonOperators.EQUAL:
      return EComparisonOperatorsDisplayText.EQUAL_TO;
    case EComparisonOperators.NOT_EQUAL:
      return EComparisonOperatorsDisplayText.NOT_EQUAL_TO;
    default:
      return '';
  }
}
